import veeValidateLocalized from '../components/VeeValidateLocalized';

import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';
import Multiselect from 'vue-multiselect';
import Pagination from 'laravel-vue-pagination';
import DataIndex from './components/DataIndex.vue';
import DataDownloadModal from './components/DataDownloadModal.vue';
import ObservationCard from '../observations/components/ObservationCard.vue';

Vue.use(DatePick);

Vue.component('date-pick', DatePick);
Vue.component('multiselect', Multiselect);
Vue.component('pagination', Pagination);
Vue.component('data-index', DataIndex);
Vue.component('data-download-modal', DataDownloadModal);
Vue.component('observation-card', ObservationCard);

const app = new Vue({
    mixins: [veeValidateLocalized],
    component: DataIndex
}).$mount('#app');
